import { render, staticRenderFns } from "./DeedOfRevocationForPowerOfAttorney.vue?vue&type=template&id=2546fb86&scoped=true&"
import script from "./DeedOfRevocationForPowerOfAttorney.vue?vue&type=script&lang=js&"
export * from "./DeedOfRevocationForPowerOfAttorney.vue?vue&type=script&lang=js&"
import style0 from "./DeedOfRevocationForPowerOfAttorney.vue?vue&type=style&index=0&id=2546fb86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546fb86",
  null
  
)

export default component.exports